export const DEFAULT_LINE_COLORS = ['#FF5733', '#28B463', '#0077ff', '#F1C40F', '#8E44AD'];

export const DISTANCE_OPTIONS = [
  { label: 'None', value: 'none' },
  { label: 'Kilometers', value: 'km' },
  { label: 'Miles', value: 'miles' },
];

export const MAP_STYLES = [
  { id: 'light', label: 'Light', image: '/map-thumbs/light.jpg' },
  { id: 'dark', label: 'Dark', image: '/map-thumbs/dark.jpg' },
  { id: 'satellite', label: 'Satellite', image: '/map-thumbs/satellite.jpg' }
];

export const visualisationDefaults = {
  animationDuration: 20000,
  mapStyle: 'light',
  lineColor: '#0077ff',
  distanceUnit: 'none',
  pitch: 60
}

export const panAmRoute = [
  [-148.3978, 70.2450],   // Prudhoe Bay, Alaska
  [-149.4937, 64.2008],   // Fairbanks, Alaska
  [-147.7227, 64.8378],   // Additional point
  [-145.7781, 61.2181],   // Anchorage, Alaska
  [-135.3239, 57.0531],   // Sitka, Alaska
  [-133.4194, 56.4986],   // Petersburg, Alaska
  [-132.9517, 56.2331],   // Prince Rupert area
  [-130.0453, 54.3161],   // Prince Rupert, BC
  [-125.2733, 54.0133],   // Prince George area
  [-123.1207, 49.2827],   // Vancouver, Canada
  [-122.6762, 45.5152],   // Portland, Oregon
  [-122.3321, 47.6062],   // Seattle, USA
  [-121.1958, 44.0582],   // Bend, Oregon
  [-119.7462, 36.7783],   // Fresno area
  [-118.2437, 34.0522],   // Los Angeles, USA
  [-117.1611, 32.7157],   // San Diego, USA
  [-116.9325, 32.5343],   // Tijuana border
  [-114.0719, 30.5383],   // Mexicali area
  [-110.9265, 29.0729],   // Hermosillo area
  [-108.9857, 25.7903],   // Culiacán area
  [-106.4102, 23.2494],   // Mazatlán area
  [-104.9734, 21.1619],   // Puerto Vallarta area
  [-103.3918, 20.6597],   // Guadalajara area
  [-101.2916, 21.8853],   // San Luis Potosí area
  [-99.1332, 19.4326],    // Mexico City, Mexico
  [-96.9167, 19.5439],    // Veracruz area
  [-94.3654, 18.1427],    // Tuxtla Gutiérrez area
  [-92.2648, 14.8411],    // Tapachula area
  [-90.5328, 14.6349],    // Guatemala border
  [-90.2307, 14.6228],    // Guatemala City area
  [-89.2073, 21.1619],    // Mérida, Mexico (if including this branch)
  [-88.7590, 15.5011],    // Puerto Barrios, Guatemala
  [-87.2069, 14.0818],    // Guatemala/Honduras border
  [-86.8515, 14.0818],    // Tegucigalpa, Honduras
  [-86.0735, 12.8654],    // Nicaragua border
  [-85.2072, 12.8654],    // Managua area
  [-85.1376, 12.1364],    // Managua, Nicaragua
  [-84.6739, 10.9335],    // Costa Rica border
  [-84.0907, 9.9281],     // San José, Costa Rica
  [-82.8661, 9.5904],     // Panama border
  [-80.7821, 8.9824],     // David, Panama
  [-79.5199, 8.9824],     // Panama City, Panama
  [-78.2624, 7.8654],     // Colombia border area
  [-77.8822, 4.6097],     // Bogotá approach
  [-77.0341, 0.8000],     // Ipiales, Colombia (border)
  [-76.5225, 3.4516],     // Cali, Colombia
  [-75.5671, 6.2518],     // Medellín, Colombia
  [-74.0721, 4.7110],     // Bogotá, Colombia
  [-74.2973, -11.0049],   // Lima approach
  [-78.4678, -0.1807],    // Quito, Ecuador
  [-79.0558, -8.1116],    // Trujillo, Peru
  [-77.0428, -12.0464],   // Lima, Peru
  [-75.0152, -14.0650],   // Cusco area
  [-71.5375, -16.4090],   // Arequipa, Peru
  [-69.3322, -15.8406],   // Bolivia border
  [-68.1193, -16.5000],   // La Paz, Bolivia
  [-66.1568, -17.3895],   // Cochabamba, Bolivia
  [-63.1811, -17.7836],   // Santa Cruz, Bolivia
  [-62.2159, -26.8083],   // Argentina border area
  [-63.5297, -24.7859],   // Tartagal, Argentina  
  [-65.4119, -24.7859],   // Salta, Argentina
  [-60.6444, -31.6100],   // Santa Fe, Argentina
  [-64.1810, -31.4201],   // Córdoba, Argentina
  [-58.3816, -34.6037],   // Buenos Aires, Argentina
  [-57.9756, -38.0055],   // Bahía Blanca area
  [-65.3095, -41.1335],   // Neuquén area
  [-68.1193, -38.9516],   // Neuquén, Argentina
  [-70.0888, -45.8667],   // Comodoro Rivadavia area
  [-70.2671, -47.7511],   // Río Gallegos, Argentina
  [-69.2181, -51.6230],   // Río Grande area
  [-68.2956, -54.8019],   // Ushuaia, Argentina
];